import React from "react";
import { connect, ConnectedProps } from 'react-redux';
import { Switch } from "react-router";
import { Container } from "semantic-ui-react";
import { ApplicationState, routes } from '../..';
import { Archiviazione } from "../../archiviazione";
import { Chiamate } from "../../chiamate";
import * as Core from '../../core';
import { Ordini } from "../../ordini";
import { AnagraficheCustom, UbicazioniCustom } from "../../user-admin";
import AnagraficaRoute from "./AnagraficaRoute";
import Home from "./Home";
import UserHeaderComputer from "./UserHeaderComputer";
import UserHeaderMobile from "./UserHeaderMobile";
import { mediaStyles, MediaContextProvider, Media } from '../../core'; 

const connector = connect(
    (state: ApplicationState) => ({
        moduli: state.core.moduli,
        logo: state.core.auth.user!.profile.picture!,
    }),
    Core.actions
)
type PropsFromRedux = ConnectedProps<typeof connector>

type PortaleProps = PropsFromRedux

class Portale extends React.Component<PortaleProps> {
    constructor(props: PortaleProps) {
        super(props);

        document.title = "Portale";
        const favicon = document.getElementById("favicon") as any;
        favicon.href = this.props.logo;
    }

    componentDidMount() {
        this.props.loadModuli();
    }

    render() {
        return (
            <div>
                <style>{mediaStyles}</style>
                <MediaContextProvider>
                    <Media greaterThanOrEqual="computer">
                        {this.renderComputer()}
                    </Media>
                    <Media lessThan="computer">
                        {this.renderMobile()}
                    </Media>
                </MediaContextProvider>
            </div>
        );
    }

    renderComputer = () => (
        <>
            <UserHeaderComputer />            
            {this.renderRoutes()}            
        </>
    )

    renderMobile = () => (
        <UserHeaderMobile>
            {this.renderRoutes()}
        </UserHeaderMobile>
    )

    renderRoutes = () => (
        <Container fluid style={{ marginTop: '7em' }}>
            <Switch>
                <AnagraficaRoute exact path='/portal' component={Home} />
                {this.props.moduli.chiamate && <AnagraficaRoute path={routes.core.main + routes.chiamate.main} component={Chiamate} />}
                {this.props.moduli.ordini && <AnagraficaRoute path={routes.core.main + routes.ordini.main} component={Ordini} />}
                {this.props.moduli.archiviazione && <AnagraficaRoute path={routes.core.main + routes.archivi.main} component={Archiviazione} />}
                {this.props.moduli.admin && <AnagraficaRoute path={routes.core.main + routes.userAdmin.anagrafiche} component={AnagraficheCustom} />}
                {this.props.moduli.admin && <AnagraficaRoute path={routes.core.main + routes.userAdmin.ubicazioni} component={UbicazioniCustom} />}
            </Switch>
        </Container>
    )
}

export default connector(Portale);